import Vuex from 'vuex'
import Vue from 'vue'
import info from './info'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    info
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js